import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app
  },
  state: {
    isShowingTokenExpiredPrompt: false,
    videos: {
      capManage:require('@/assets/vedios/capManage.mp4'),
      probManage:require('@/assets/vedios/probManage.mp4'),


    },
    currentVideo: null,
  },
  mutations: {
    setIsShowingTokenExpiredPrompt(state, value) {
      state.isShowingTokenExpiredPrompt = value;
    },
    setCurrentVideo(state, videoUrl) {
      state.currentVideo = videoUrl;
    },

  },
  actions: {
    setCurrentVideo({ commit }, videoUrl) {
      commit('setCurrentVideo', videoUrl);
    },
  },
})
